"use client";

/**
 * FooterBrand.tsx
 *
 * Left-most column of the footer.
 * Shows the brand title, description, and social links.
 */

import React from "react";
import Link from "next/link";

interface SocialLink {
  name: string;
  href: string;
}

interface FooterBrandProps {
  title: string;
  description: string;
  socialLinks: SocialLink[];
}

const FooterBrand = ({ title, description, socialLinks }: FooterBrandProps) => {
  return (
    <div className="flex flex-col space-y-8">
      <span className="font-cormorant text-4xl font-bold uppercase tracking-widest text-white">
        {title}
      </span>
      <p className="text-sm text-gray-400 leading-relaxed font-light">
        {description}
      </p>

      {/* Socials */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-4">
        {socialLinks.map((link, idx) => (
          <Link
            key={`${link.name}-${idx}`}
            href={link.href}
            target="_blank"
            className="text-xs font-bold tracking-widest uppercase text-gray-400 hover:text-[#c59d5f] transition-colors"
          >
            {link.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FooterBrand;
